import { Controller } from "@hotwired/stimulus";
import { clearFieldErrors } from "../lib/clear_field_errors";

export default class extends Controller {
  static targets = ["regular", "exclusive", "exclusiveOption", "picker", "status", "statusLabel", "error"];

  connect() {
    this.updateStatus();
  }

  chooseStatus() {
    const value = this.pickerTarget.value;
    if (value !== "reported") {
      this.regularTargets.forEach(input => { input.checked = false; });
    }
    this.exclusiveTarget.value = value === "reported" ? "" : value;
    this.updateStatus();
    clearFieldErrors(this.element);
  }

  chooseRace() {
    this.exclusiveTarget.value = "";
    this.exclusiveOptionTargets.forEach(input => { input.checked = false; });
    this.updateStatus();
    clearFieldErrors(this.element);
  }

  chooseExclusive({ target }) {
    this.exclusiveOptionTargets.forEach(input => { if (input !== target) input.checked = false; });
    if (target.checked) this.regularTargets.forEach(input => { input.checked = false; });
    this.exclusiveTarget.value = target.checked ? target.value : "";
    clearFieldErrors(this.element);
  }

  updateStatus() {
    if (!this.hasPickerTarget) return;

    const reported = this.regularTargets.some(input => input.checked);
    this.pickerTarget.value = this.exclusiveTarget.value || (reported ? "reported" : "");
    const option = this.pickerTarget.selectedOptions[0];
    this.statusLabelTarget.textContent = option?.dataset.status || this.pickerTarget.options[0].dataset.status;
    this.statusTarget.dataset.quality = option?.dataset.quality || "";
  }
}
